export const Types = {
    SAVE_LIST_ORDER: 'SAVE_LIST_ORDER',
    SAVE_LIST_VOUCHER: 'SAVE_LIST_VOUCHER',
    SAVE_LIST_USER_VOUCHER: 'SAVE_LIST_USER_VOUCHER',
}
